import React from 'react'
import Link from 'gatsby-link'

import './index.css'

const Footer = () => (
  <footer id="app-footer">
    <section className="sitemap">
      <Link to="/" className={'nav-home'}></Link>
      <div>
        <h5><Link to="/">Johnny Metrics</Link></h5>
        <Link to="/#pricing">Pricing</Link>
        <a href={`${process.env.APP_URL}/signin`}>Log in</a>
        <a href={`${process.env.APP_URL}/signup`}>Sign up for a free trial</a>
        <a href={process.env.DEMO_ENDPOINT}>Demo</a>
      </div>
      <div>
        <h5>Keep in touch</h5>
        <a href="mailto:info@johnnymetrics.com">Email us</a>
      </div>
      <div>
        <h5>Fine print</h5>
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms of service</Link>
        <Link to="/security">Security overview</Link>
      </div>
    </section>
    <section className="copyright">Brought to you by your friends at Johnny Metrics | © 2017 - 2018;  BREAKFAST 61, Accounts Department 6, Castlewood House, 77-91 New Oxford Street, London, WC1A 1DG</section>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js